<template>
	<div id="app">
		<div data-v-53517552="" class="confirmOrderStyle">
			<div data-v-eeb85202="" data-v-53517552="" class="titlesStyle mb30">
				<div data-v-eeb85202="" class="title-info-box w1300 mauto">
					<div data-v-eeb85202="" class="title-box">
						<div data-v-eeb85202="" class="logo-box flex-between align-center"><img data-v-eeb85202=""
																																										src="@/assets/img/default1/logob.png" alt="">
							<!---->
							<div data-v-eeb85202="" class="content col666 flex-start align-center ml20 pl20">
								<div data-v-eeb85202="" class="f20" style="color: rgb(102, 102, 102);">
									{{ merchant.sitename }}
								</div>
							</div>
						</div>
						<div data-v-eeb85202="" class="right-menu-btn">
							<div data-v-eeb85202="" class="middel-btn l-btn flex-center align-center">
								<el-popover
									placement="top-end"
									width="220"
									trigger="hover">
									<div>
										<p v-if="merchant.qq">
											<span style="width:36px;line-height: 36px;">QQ：</span>
											{{ merchant.qq }}
											<el-button @click="_copy(merchant.qq)" type="text">复制</el-button>
										</p>
										<el-divider></el-divider>
										<p v-if="merchant.mchWechat">
											<span style="width:36px;line-height: 36px;">微信：</span>
											{{ merchant.mchWechat }}
											<el-button @click="_copy(merchant.mchWechat)" type="text">复制</el-button>
										</p>
									</div>
									<span slot="reference" data-v-eeb85202="">卖家信息</span>
								</el-popover>
							</div>
							<!---->
							<div data-v-eeb85202="" class="middel-btn y-btn flex-center align-center">
								<a style="color: #fff; text-decoration: none;" href="https://jijuxjs.cn/"><span data-v-eeb85202="">官网首页</span></a>
							</div>
							<div data-v-eeb85202="" class="middel-btn l-btn flex-center align-center">
								<el-popover
									placement="top-end"
									width="220"
									trigger="hover">
									<div>
										<p v-if="config">
											<span style="width:36px;line-height: 36px;">QQ：</span>
											{{ config.qq }}
											<el-button @click="_copy(config.qq)" type="text">复制</el-button>
										</p>
										<el-divider></el-divider>
										<p v-if="config">
											<span style="width:36px;line-height: 36px;">电话：</span>
											{{ config.tel }}
											<el-button @click="_copy(config.tel)" type="text">复制</el-button>
										</p>
										<p v-if="config">
											<span style="width:36px;line-height: 36px;">微信：</span>
											{{ config.wechartName }}
											<el-button @click="() => concatWx()" type="text">联系</el-button>
										</p>
									</div>
									<span slot="reference" data-v-eeb85202="">官方客服</span>
								</el-popover>
							</div>
							<div data-v-eeb85202="" class="middel-btn flex-center align-center">
								<a style="color: #fff; text-decoration: none;" href="https://jijuxjs.cn/orderSearch"><span data-v-eeb85202="">订单查询</span></a>
							</div>
							<!---->
							<!---->
						</div>
					</div>
				</div>
			</div>

			<div data-v-53517552="" class="w1300 mauto" style="position: relative;">

				<div data-v-53517552="" class="other-info">
					<div v-if="cateList && cateList.length > 0" data-v-49d5ee86="" data-v-057a54f2="" id="goodsMenu" class="pb20 ">
						<div data-v-49d5ee86="" class="goods-title-box">
							<div data-v-49d5ee86="" class="flex-start align-center">
								<img data-v-49d5ee86=""
										 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAYAAABiFp9rAAAAAXNSR0IArs4c6QAABFpJREFUSEvtll+IVFUcx7+/c2fGHUvX3RahZZyZe2foIYn+koS9lA/1EJQpWBhJlAnSX0iiMjXxoShMwexFQvAhoh5K8sHopYJISkKDTas55842Q5qsa7uNu3t3zv3G2WaX2fEOmERPncdz7vd+fud3fr/vOYL/aEiL4xUKhaWe56WTuFEU2Vqt9juA6dn1IAh6RWQxydl/zJPGcTwWhuGF2cmZj3zffwTAGyLSlwQieRHAu8aYbQBYKpWWxXF8SERuBeB10ZwQkUe11j+79RlQEATDABYA+KyL6DYRCeI4LoRheKZUKm0h+TqAowBGOjUkF4vIfQB2aa23t4NiAEcmJyfXJYGy2ewrJF8meaMx5mQQBLsBPG+tvX56erraqfE8b0k6na4DeE9r/Xg7iAA+1lqvTgIFQeCi2kHyJmPMiSAI3gbwHMmiMeYSULFYXKKUGgVwUGv92P+gfyd1IvJJpVJ5oMsZ7QCwvfOMrLVBtVo1nZpcLtefyWRcNV5yRuMkfyH5UhJIKbURwOpms1keHh7Wvu/vEhFXiU87XadGKXWtqziS7xhjnmovhgMkXcVNdXGkDICKMWYlgGahULjD87wPAaRIutaYN0REuYk4jjeEYeh67e+GdVv1PG9FKpValgSy1o41m82varWa6w03vGKxeINS6hYRSSVpms3mdwMDAz8cP358xrbafcqJE70uDEPb7nOtH8vg4GA2nU73ep63yFrricgEgAsLFy68ODQ05ACuP2fGDKhcLi+21hZJ9idFJyKjURTV6vX6nN20NPc6hxCRawC4dE2SPKqU2lOpVGqXgFqW8nBSvtsC+tIYsx6AzeVy2Uwm8xbJdSIyCcC5wx8ArmsFO0zyoTAMT83bke/7Iy5qknu6FMMaEbmTZNlZTrFY3KSU2kvyGwDPTk9P/5rJZCzJJQ6glNoK4Psoiu6p1WounXPu7Srn076+vjVJoPPnz28Tka2uj/r7+4dGR0d/BLCI5O2dXlculxdYa98EsBnAQ8aYj9pBl22qSilX0t+S3GeMeSYpsFKpVCb5E8lDxpgNVwQCkBeRwyQ3GmMOdEm1CoJgDMAxrfWqKwW5K/wLd21orV9LAg0ODg709PT8BuCw1nrmOGZv2MtOHcmqiNRERKfT6ZWnT58e74B5QRBsArAPwAtaa3dJzi+Gnp6etUkRTkxMvNoqhpkb1vf9vSKymeT+KIp29vb2jmezWY6MjHgk7/I87yDJZhRFK+r1uuunOdAZkhMi8kGXnN8N4OapqSnfCfP5fF8qlXJe57zvawAulc6Yl4vI/QB6AZwEsEpr7fprDuRc+8XWA6ULC+9rrZ9wXuk+KJVKS0nuJLlWRK5uzQvJYwA+F5EtcRwfaTQaT547d+7PWa9b4Pt+0Vo7kERJpVJjjUZDnz17ttGxnsnn8znP85Yrpa6y1hql1Cmt9bjv++tFZD+A3e4llPj467alfzivfN9/MI7jiWq1euQvY1CbOtruKFIAAAAASUVORK5CYII="
										 alt="" style="width: 26px; height: 26px;"> <span data-v-49d5ee86=""
																																			class="f20 ml10" style="color: rgb(34, 34, 34);">
                    选择分类：</span>
							</div>
							<div class="category_list" style="display: flex;flex-wrap: wrap;">

								<div v-for="item in cateList" :key="item.id" @click="handleChangeCate(item)" style="cursor:pointer" :class="['category_box',selectedCateid === item.id ? 'active' : '']" data-cateid="67">
									<img
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAABDlBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////uKVtWAAAAWnRSTlMAAgMEBQYHCBAREhMWHR4gJicqKywtLi8xMjM0NTY5Ojs9Pj9AQUJDREVGR0hJSktMTU5PUVJTVFVWV1laW11gYmNkZWZoaWpsbm9wcXJzdHV3eHl6e3x9fn8hmsUDAAACRElEQVR4Xq3XbVfaMBjH4ZvVYhkoYhWsFcfK+i+iU+Z0Pk11m49zE1ER8/2/yBxrThJaSNuz6/0vzemL5A7FM4pl2200gWbDtctFgxLLzy77UPjLs9OUhFXlpdpXLdIpOBjLKdAk5jwmmjdprJIHDa9E8XJzSGAuRzHeLCERZ4oiplaQUD1SG6LVWjFIkVuCVut0LayXciSrQGury64QqpCkBK2DPmPsGKGSaPMeNILv7K/Bdhh7eeIWofHxF/un1w7rRd4WoLH3xLhrhAph7Cgfud2HKvjGJDth7NCQBcmXJ9bfhGzjlgn9PXDWMK6KNDh9YYzdBRB2H5nwW1q3Sq9MH9z6DRs6V1YTfgQQfJOIZsB9emChQ7Ga0D+AYkb5Xe0ej587w3bngQndLagcIsMHh+0Br7stACfyli9aGOEbVITkmHGXaF8zYXCEqCKVIbti3FmPCfcdxCiTDdnaPYtxuYY4NrlQdAaRdPAV8VxqQHU02vY+Y4wGNTHiQm2v2xinSRjV6spbPsEEhIjOs2bL3AdqIuKQtzfrmOQ9NRB1PkxfTgNM9I5cRAV3r+3jLjRcshFjs89+bkDHpjLi7J8F0CpTEZkVyfCRkW8QOcjI4cdQFjP8AExHHIBUQyY1fuhnYfHrJgNHXHTpvRVXbGqL8uWekpeXx4qUSupAk0ol9SglODlSTNWB7COgmbiumxRhJB5cs4/Mldx/HNYF08ZEtpn5gbJcIB2rFv80qlmUxHTWR5l4Di64q57ve6vuwtjn4B94/uYnspcNGwAAAABJRU5ErkJggg==">
									<div class="cate_name">{{ item.name }}</div>
									<div class="cate_desc">包含{{ item.count }}种商品</div>
								</div>
								<!-- <div style="cursor:pointer" class="category_box" data-cateid="207">
									<img
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAABDlBMVEX////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////uKVtWAAAAWnRSTlMAAgMEBQYHCBAREhMWHR4gJicqKywtLi8xMjM0NTY5Ojs9Pj9AQUJDREVGR0hJSktMTU5PUVJTVFVWV1laW11gYmNkZWZoaWpsbm9wcXJzdHV3eHl6e3x9fn8hmsUDAAACRElEQVR4Xq3XbVfaMBjH4ZvVYhkoYhWsFcfK+i+iU+Z0Pk11m49zE1ER8/2/yBxrThJaSNuz6/0vzemL5A7FM4pl2200gWbDtctFgxLLzy77UPjLs9OUhFXlpdpXLdIpOBjLKdAk5jwmmjdprJIHDa9E8XJzSGAuRzHeLCERZ4oiplaQUD1SG6LVWjFIkVuCVut0LayXciSrQGury64QqpCkBK2DPmPsGKGSaPMeNILv7K/Bdhh7eeIWofHxF/un1w7rRd4WoLH3xLhrhAph7Cgfud2HKvjGJDth7NCQBcmXJ9bfhGzjlgn9PXDWMK6KNDh9YYzdBRB2H5nwW1q3Sq9MH9z6DRs6V1YTfgQQfJOIZsB9emChQ7Ga0D+AYkb5Xe0ej587w3bngQndLagcIsMHh+0Br7stACfyli9aGOEbVITkmHGXaF8zYXCEqCKVIbti3FmPCfcdxCiTDdnaPYtxuYY4NrlQdAaRdPAV8VxqQHU02vY+Y4wGNTHiQm2v2xinSRjV6spbPsEEhIjOs2bL3AdqIuKQtzfrmOQ9NRB1PkxfTgNM9I5cRAV3r+3jLjRcshFjs89+bkDHpjLi7J8F0CpTEZkVyfCRkW8QOcjI4cdQFjP8AExHHIBUQyY1fuhnYfHrJgNHXHTpvRVXbGqL8uWekpeXx4qUSupAk0ol9SglODlSTNWB7COgmbiumxRhJB5cs4/Mldx/HNYF08ZEtpn5gbJcIB2rFv80qlmUxHTWR5l4Di64q57ve6vuwtjn4B94/uYnspcNGwAAAABJRU5ErkJggg==">
									<div class="cate_name">分类</div>
									<div class="cate_desc">包含2种商品</div>
								</div> -->

							</div>
						</div>
					</div>
					<div data-v-49d5ee86="" class="flex-start align-center pb30">
						<img data-v-49d5ee86=""
								 src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAYAAABiFp9rAAAAAXNSR0IArs4c6QAABFpJREFUSEvtll+IVFUcx7+/c2fGHUvX3RahZZyZe2foIYn+koS9lA/1EJQpWBhJlAnSX0iiMjXxoShMwexFQvAhoh5K8sHopYJISkKDTas55842Q5qsa7uNu3t3zv3G2WaX2fEOmERPncdz7vd+fud3fr/vOYL/aEiL4xUKhaWe56WTuFEU2Vqt9juA6dn1IAh6RWQxydl/zJPGcTwWhuGF2cmZj3zffwTAGyLSlwQieRHAu8aYbQBYKpWWxXF8SERuBeB10ZwQkUe11j+79RlQEATDABYA+KyL6DYRCeI4LoRheKZUKm0h+TqAowBGOjUkF4vIfQB2aa23t4NiAEcmJyfXJYGy2ewrJF8meaMx5mQQBLsBPG+tvX56erraqfE8b0k6na4DeE9r/Xg7iAA+1lqvTgIFQeCi2kHyJmPMiSAI3gbwHMmiMeYSULFYXKKUGgVwUGv92P+gfyd1IvJJpVJ5oMsZ7QCwvfOMrLVBtVo1nZpcLtefyWRcNV5yRuMkfyH5UhJIKbURwOpms1keHh7Wvu/vEhFXiU87XadGKXWtqziS7xhjnmovhgMkXcVNdXGkDICKMWYlgGahULjD87wPAaRIutaYN0REuYk4jjeEYeh67e+GdVv1PG9FKpValgSy1o41m82varWa6w03vGKxeINS6hYRSSVpms3mdwMDAz8cP358xrbafcqJE70uDEPb7nOtH8vg4GA2nU73ep63yFrricgEgAsLFy68ODQ05ACuP2fGDKhcLi+21hZJ9idFJyKjURTV6vX6nN20NPc6hxCRawC4dE2SPKqU2lOpVGqXgFqW8nBSvtsC+tIYsx6AzeVy2Uwm8xbJdSIyCcC5wx8ArmsFO0zyoTAMT83bke/7Iy5qknu6FMMaEbmTZNlZTrFY3KSU2kvyGwDPTk9P/5rJZCzJJQ6glNoK4Psoiu6p1WounXPu7Srn076+vjVJoPPnz28Tka2uj/r7+4dGR0d/BLCI5O2dXlculxdYa98EsBnAQ8aYj9pBl22qSilX0t+S3GeMeSYpsFKpVCb5E8lDxpgNVwQCkBeRwyQ3GmMOdEm1CoJgDMAxrfWqKwW5K/wLd21orV9LAg0ODg709PT8BuCw1nrmOGZv2MtOHcmqiNRERKfT6ZWnT58e74B5QRBsArAPwAtaa3dJzi+Gnp6etUkRTkxMvNoqhpkb1vf9vSKymeT+KIp29vb2jmezWY6MjHgk7/I87yDJZhRFK+r1uuunOdAZkhMi8kGXnN8N4OapqSnfCfP5fF8qlXJe57zvawAulc6Yl4vI/QB6AZwEsEpr7fprDuRc+8XWA6ULC+9rrZ9wXuk+KJVKS0nuJLlWRK5uzQvJYwA+F5EtcRwfaTQaT547d+7PWa9b4Pt+0Vo7kERJpVJjjUZDnz17ttGxnsnn8znP85Yrpa6y1hql1Cmt9bjv++tFZD+A3e4llPj467alfzivfN9/MI7jiWq1euQvY1CbOtruKFIAAAAASUVORK5CYII="
								 alt="" style="width: 26px; height: 26px;"> <span data-v-49d5ee86=""
																																	class="f20 ml10" style="color: rgb(34, 34, 34);">
                选择商品：</span>
					</div>
					<div data-v-1912a063="" class="goods-list-table">
            <div v-show="isList" class="search_box">
              <input   type="text" v-model="searchTitle"  placeholder="输入商品名称进行查找">
              <div   class="search_btn" @click="searchGoods">搜索</div>
            </div>
						<div v-for="item in cateGoodsList" :key="item.id" @click="handleChangeGoods(item.id)" :class="['goods-item-box', 'flex-column', 'align-start',order.goodid === item.id ? 'active' : '']" data-v-1912a063="">
							<div data-v-1912a063="" class="top flex-start align-center">
								<img v-if="goods && goods.id === item.id" data-v-1912a063="" :src="goods.avatarUrl" alt="" class="good-img">
								<img v-else data-v-1912a063="" src="@/assets/img/default1/goods.png" alt="" class="good-img">
								<p data-v-1912a063="" class="col666 f14 ml10 hidden-four"
									 style="overflow-wrap: break-word; max-width: 210px;">
									{{ item.name }}
								</p>
							</div>
							<div v-if="goods && goods.id === item.id" data-v-1912a063="" class="good-info-box flex-start align-center">
								<label data-v-1912a063="" class="colF71148 f14 fontw">
									￥<span data-v-1912a063="" class="f20 ml5">{{ order.price }}</span>
								</label>
								<div data-v-1912a063="" class="flex-start align-center ml10" style="width: 100%;">
									<div data-v-1912a063="">
										<span data-v-1912a063="" class="f14 ls1" :style="{color : kucunColor}">{{ kucunDesc ? kucunDesc : "库存" + goods.kucun + "件" }}</span>
									</div>
								</div>
							</div>
							<i data-v-1912a063="" class="iconfont iconxuanze select"></i>
						</div>
					</div>

					<div v-if="goods">
						<div data-v-53517552="" class="flex-start align-center pb30"><img data-v-53517552=""
																																							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAgdJREFUSEvllrFrFEEUxt83dxyxSxFQ7lK8GQQLFRFSWKRQsLMwYkTBiIWVnX+Chb2thWVAxYgWkVgcaCGIINgoCHI7c7lcYWcheIe388nIraxFzg2cV5jpZvbt+833zcybgcyoYUYcmR1IVQ8BeABgWUTqU1Y4EpEXw+HwJpxzT0VkheQrAF+nCSI5D+A0yXYC/SD52nt/ZpqQIpe19mVyK4EoIs+yLLvwL0CFY/sIpKrztVptsdPpfChb2mq1FlO/3+/vlMbrqnpMREII4Y8NNdG68ZZ/A0DL66eq140x99MxiDFeCSE8SrAimYjskFzy3n8pJjER5Jy7KCIbRXCM8UAIYeCceywiq2mc5Ib3/pKqzhljvpfUrWZZ9qQSKNkG4H1SRHLde38t/aiq540xD5OiPM9Xut3u87IikkFETlVWNE46l+d5q9frdcprZK09mPrlZKlvrT3ivU+xqRr8bvtwe0+rSvzf1n0muQBgLcb4bYJlgxDC2+J7s9lcaDQaR/9icTom90RkAFW9bIxZr3jpFYex7pzbEpGzFdZyFGNc+3WVW2tPiMgygF1vWJK3xxXhJICrAO6Q3ATQngQbjUbt7e3tj5XfDM65cyKySfITgMOpgMYYj6fSVEHV3h4nqnrXGHOL5CDP86U00yqQFFNZUVGWANwg+a68MarA9gSqknC3mJ+oSyAwPE+U7gAAAABJRU5ErkJggg=="
																																							alt="" style="width: 28px; height: 28px;">
							<span data-v-53517552=""
										class="col000 f20 ml15">商品描述</span></div>
						<div data-v-53517552="" class="goods-descript mb20">
							<div data-v-53517552="" class="mt10" v-html="goods.remark"></div>
							<!--<div v-html="remark"></div>-->
						</div>
					</div>

					<div data-v-53517552="" class="flex-start align-center mb10">
						<span data-v-53517552="" style="margin-right: 20px;" class="col000 f18 ml15">购买数量</span>
					</div>
					<div data-v-53517552="" style="display: flex;position: relative">
						<div>
							<el-input-number v-model="order.quantity" :min="minLimit !==0 ? minLimit :1" :precision="0" :max="goods ? maxLimit : 1" label="描述文字"></el-input-number>
							<div data-v-53517552="" class="f12 col666 mt10">请输入购买数量</div>
						</div>
						<div style="margin-left: 250px;position: absolute;top: -40px;display: flex;flex-wrap: wrap;">
							<div v-for="(item,index) in goodlistManzengVos" :key="index" class="text item" style="display: inline-block;color: #ff0000;font-size: 17px;font-family: PingFang SC;">
								<el-badge :value="`赠${item.zengsong}`" class="item" style="margin-right: 30px;margin-top: 10px;">
									<el-button size="small">{{ "买" + item.manzu }}</el-button>
								</el-badge>
							</div>
						</div>
					</div>
					<div data-v-53517552="" class="mv20">
						<div data-v-53517552="" class="ivu-divider ivu-divider-horizontal ivu-divider-default">
							<!---->
						</div>
					</div>

					<div data-v-53517552="" class="flex-start align-center mb10"><img data-v-53517552=""
																																						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA7dJREFUSEvNlk9oXFUUxr/z3ks60gYCJpDk/Q3MomCllRoq2IJFoQoVImahGHChiyxazKLSCoqKuKqLQhUiFlQo6KJSChELLoxQoWBEhYqbmMybd99kbLqokNrMzHv3k5dkxiRNMzNBgm97z7m/85177nefYIc/2WEe/l/AIAhy1ao+CNARkZyIJFqzUKvd/XVhYWFxO93ZVKHjBIcAnhDBCEkLQAGQDJBbhVskpkh8GMfh1+2A1wEzRWnKsyTHSFzUml/u3r1ramZmprJmU2tgwDtkmhgBZAzAVa2Tk3Ecq1bADeAq7DKAvUnCkfn54k/NNujvH/RNU38mgqBWqxwtl8uFZjkNoOv6Z4GshelhpVTcLPHf9SDnOMwK7VYqPAIg2Sp3GWjbg/tF0mlAP6WU+r512Epkd3fQ3dXFORKvKhV+1RTouv55koFSxWfbhdXj+/q8h9L0bthsepcVOo7/swguRFH4UTvAgYGBHsB80jDkgAi6ASyRKKQprt1vBpaBruvPATIeRYUrrQBt23YMw3yPxCiAMiDTIrxNSnaF8gAfBeSGiH4niqJ1ezYUkpyI4+LHzYCe5z1OyiWAM2mKM6VS8YeNObZtP2gY1jiAUyTPKVV8ox5TV3iehKNU+NxWwL6+ILAs/eNKcdFbzYrr7/cOWpZMZvFKFd/N4peB2YJp4nqS4EC5XPztfhu5rn+ZRE6p8JlmsPq667rHSJmsVrn35s3ojzX30PuUlMcqlb+HNpu0TF1HB+dqNe7bqqjNCnEc/zsA00qFr6+xtiDnuvpbUhKlwqMbEx3Hf14EH0RRONiqunqc43inReR4FIVH1nmp6y6rzBzjnrP0vOBlrTmuVPhI+0D/FRGORVFxqAHM7pRpdkRa87iIDg3DPE1mVodfANwQQQ+A4SgKu5rZ1ybd+YTEnjgOX2wAHcd7DcCbIphcuV9yTWs9YRgSALKPhGUYeDpTGcfFz1tVuXr2v6epfqFUiq6sAfovZW5D4iqQntvMU+tFJUl1qJWXobe3d08u98A3pCzWJ7vtXwzX9b8geRjQo82MfvUFGk3T2sOlUulW4x622p7VOMu2/bcNI3MRTAG4ZBi8Xq0ad9I0sTo7DT/z1krFuGhZad4wshgd1J+8thXWi7Nte7+INQpwWETya4q+TfKWiDgAJwAZ1hoX4jh8f7sK72lIPp/ftbS01NPZ2bk4Ozv718qDEBwjeUYET2T/PkqFJ/8z4FZHkv2GzM/zT6CwtCPAjcVs+wzbHLRG+D/+gL0sHWmsTwAAAABJRU5ErkJggg=="
																																						alt="" style="width: 24px; height: 24px;">
						<span data-v-53517552=""
									class="col000 f18 ml15">联系方式</span></div>
					<div data-v-53517552="">
						<input v-model="order.contact" data-v-53517552="" placeholder="必填"
									 class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
						<div v-if="goods && goods.contactLimit === 2" data-v-53517552="" class="f12 col666 mt10">请输入QQ号，可用于查询订单</div>
						<div v-else-if="goods && goods.contactLimit === 3" data-v-53517552="" class="f12 col666 mt10">请输入手机号，可用于查询订单</div>
						<div v-else-if="goods && goods.contactLimit === 4" data-v-53517552="" class="f12 col666 mt10">请输入微信号，可用于查询订单</div>
						<div v-else data-v-53517552="" class="f12 col666 mt10">请输入联系方式，可用于查询订单</div>
					</div>
					<div data-v-53517552="" class="mv20">
						<div data-v-53517552="" class="ivu-divider ivu-divider-horizontal ivu-divider-default">
							<!---->
						</div>
					</div>

					<div data-v-53517552="" class="flex-start align-center mb10"><img data-v-53517552=""
																																						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA7dJREFUSEvNlk9oXFUUxr/z3ks60gYCJpDk/Q3MomCllRoq2IJFoQoVImahGHChiyxazKLSCoqKuKqLQhUiFlQo6KJSChELLoxQoWBEhYqbmMybd99kbLqokNrMzHv3k5dkxiRNMzNBgm97z7m/85177nefYIc/2WEe/l/AIAhy1ao+CNARkZyIJFqzUKvd/XVhYWFxO93ZVKHjBIcAnhDBCEkLQAGQDJBbhVskpkh8GMfh1+2A1wEzRWnKsyTHSFzUml/u3r1ramZmprJmU2tgwDtkmhgBZAzAVa2Tk3Ecq1bADeAq7DKAvUnCkfn54k/NNujvH/RNU38mgqBWqxwtl8uFZjkNoOv6Z4GshelhpVTcLPHf9SDnOMwK7VYqPAIg2Sp3GWjbg/tF0mlAP6WU+r512Epkd3fQ3dXFORKvKhV+1RTouv55koFSxWfbhdXj+/q8h9L0bthsepcVOo7/swguRFH4UTvAgYGBHsB80jDkgAi6ASyRKKQprt1vBpaBruvPATIeRYUrrQBt23YMw3yPxCiAMiDTIrxNSnaF8gAfBeSGiH4niqJ1ezYUkpyI4+LHzYCe5z1OyiWAM2mKM6VS8YeNObZtP2gY1jiAUyTPKVV8ox5TV3iehKNU+NxWwL6+ILAs/eNKcdFbzYrr7/cOWpZMZvFKFd/N4peB2YJp4nqS4EC5XPztfhu5rn+ZRE6p8JlmsPq667rHSJmsVrn35s3ojzX30PuUlMcqlb+HNpu0TF1HB+dqNe7bqqjNCnEc/zsA00qFr6+xtiDnuvpbUhKlwqMbEx3Hf14EH0RRONiqunqc43inReR4FIVH1nmp6y6rzBzjnrP0vOBlrTmuVPhI+0D/FRGORVFxqAHM7pRpdkRa87iIDg3DPE1mVodfANwQQQ+A4SgKu5rZ1ybd+YTEnjgOX2wAHcd7DcCbIphcuV9yTWs9YRgSALKPhGUYeDpTGcfFz1tVuXr2v6epfqFUiq6sAfovZW5D4iqQntvMU+tFJUl1qJWXobe3d08u98A3pCzWJ7vtXwzX9b8geRjQo82MfvUFGk3T2sOlUulW4x622p7VOMu2/bcNI3MRTAG4ZBi8Xq0ad9I0sTo7DT/z1krFuGhZad4wshgd1J+8thXWi7Nte7+INQpwWETya4q+TfKWiDgAJwAZ1hoX4jh8f7sK72lIPp/ftbS01NPZ2bk4Ozv718qDEBwjeUYET2T/PkqFJ/8z4FZHkv2GzM/zT6CwtCPAjcVs+wzbHLRG+D/+gL0sHWmsTwAAAABJRU5ErkJggg=="
																																						alt="" style="width: 24px; height: 24px;">
						<span data-v-53517552="" style="margin-right: 20px;" class="col000 f18 ml15">短信提醒</span>
						<el-switch v-model="order.isTel" active-color="#13ce66" :active-value="1" :inactive-value="0"></el-switch>
					</div>
					<div data-v-53517552="">
						<input v-if="order.isTel === 1" v-model="order.tel" data-v-53517552="" placeholder="请输入手机号码接收短信提醒"
									 class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
						<div data-v-53517552="" class="f12 col666 mt10">使用该服务，会收取0.1元手续费</div>
					</div>
					<div data-v-53517552="" class="mv20">
						<div data-v-53517552="" class="ivu-divider ivu-divider-horizontal ivu-divider-default">
							<!---->
						</div>
					</div>

					<div data-v-53517552="" class="flex-start align-center mb10"><img data-v-53517552=""
																																						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA7dJREFUSEvNlk9oXFUUxr/z3ks60gYCJpDk/Q3MomCllRoq2IJFoQoVImahGHChiyxazKLSCoqKuKqLQhUiFlQo6KJSChELLoxQoWBEhYqbmMybd99kbLqokNrMzHv3k5dkxiRNMzNBgm97z7m/85177nefYIc/2WEe/l/AIAhy1ao+CNARkZyIJFqzUKvd/XVhYWFxO93ZVKHjBIcAnhDBCEkLQAGQDJBbhVskpkh8GMfh1+2A1wEzRWnKsyTHSFzUml/u3r1ramZmprJmU2tgwDtkmhgBZAzAVa2Tk3Ecq1bADeAq7DKAvUnCkfn54k/NNujvH/RNU38mgqBWqxwtl8uFZjkNoOv6Z4GshelhpVTcLPHf9SDnOMwK7VYqPAIg2Sp3GWjbg/tF0mlAP6WU+r512Epkd3fQ3dXFORKvKhV+1RTouv55koFSxWfbhdXj+/q8h9L0bthsepcVOo7/swguRFH4UTvAgYGBHsB80jDkgAi6ASyRKKQprt1vBpaBruvPATIeRYUrrQBt23YMw3yPxCiAMiDTIrxNSnaF8gAfBeSGiH4niqJ1ezYUkpyI4+LHzYCe5z1OyiWAM2mKM6VS8YeNObZtP2gY1jiAUyTPKVV8ox5TV3iehKNU+NxWwL6+ILAs/eNKcdFbzYrr7/cOWpZMZvFKFd/N4peB2YJp4nqS4EC5XPztfhu5rn+ZRE6p8JlmsPq667rHSJmsVrn35s3ojzX30PuUlMcqlb+HNpu0TF1HB+dqNe7bqqjNCnEc/zsA00qFr6+xtiDnuvpbUhKlwqMbEx3Hf14EH0RRONiqunqc43inReR4FIVH1nmp6y6rzBzjnrP0vOBlrTmuVPhI+0D/FRGORVFxqAHM7pRpdkRa87iIDg3DPE1mVodfANwQQQ+A4SgKu5rZ1ybd+YTEnjgOX2wAHcd7DcCbIphcuV9yTWs9YRgSALKPhGUYeDpTGcfFz1tVuXr2v6epfqFUiq6sAfovZW5D4iqQntvMU+tFJUl1qJWXobe3d08u98A3pCzWJ7vtXwzX9b8geRjQo82MfvUFGk3T2sOlUulW4x622p7VOMu2/bcNI3MRTAG4ZBi8Xq0ad9I0sTo7DT/z1krFuGhZad4wshgd1J+8thXWi7Nte7+INQpwWETya4q+TfKWiDgAJwAZ1hoX4jh8f7sK72lIPp/ftbS01NPZ2bk4Ozv718qDEBwjeUYET2T/PkqFJ/8z4FZHkv2GzM/zT6CwtCPAjcVs+wzbHLRG+D/+gL0sHWmsTwAAAABJRU5ErkJggg=="
																																						alt="" style="width: 24px; height: 24px;">
						<span data-v-53517552="" style="margin-right: 20px;" class="col000 f18 ml15">邮件提醒</span>
						<el-switch v-model="order.isEmail" active-color="#13ce66" :active-value="1" :inactive-value="0"></el-switch>
					</div>
					<div data-v-53517552="">
						<input v-if="order.isEmail === 1" v-model="order.email" data-v-53517552="" type="text" placeholder="请输入邮箱号码接收短信提醒"
									 class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
						<div data-v-53517552="" class="f12 col666 mt10">使用该服务免费</div>
					</div>
					<div data-v-53517552="" class="mv20">
						<div data-v-53517552="" class="ivu-divider ivu-divider-horizontal ivu-divider-default">
							<!---->
						</div>
					</div>

					<div v-if="goods && goods.isPwd === 1">
						<div data-v-53517552="" class="flex-start align-center mb10"><img data-v-53517552=""
																																							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAfNJREFUSEvtlb9rFEEUx79vvJCVpLBZONiZ2ylSWNhpI/gHaKeVFqYQU14hmJCU11nYHihYiIWVlYWF+A9YWAgRrOSyN7Oc5HKIIMmF7O6TNSrH3bmzLMtBwGnfzPu89533g7DgQwvm4T/wr+K+768uL59/CNBNgC8BGBPRR2Y8tTZ6WfZrSknabGq9tJS9Y/7ltguI90DiMZ+7JgTaAH8aj49uDYfDHy6wE6i19tKUPzPzB2vFOrA3nnTq+7rpedmrPGNj+jcAJEVQJ1DK1iOArltLV6dhfxwHQSCFaOwyo+2S1wlUKuxlGXfiuP+iKHKlwsfMaFobrVfOUGt9IU352/Fxtra/b74U/4/2guBkJY7jUWXgabFwL0mEHgx6kasgytjnSiplaxvABgCPiCQzWyIqLIZJGDO+EmUdY8zb6SBmgEqp28zUBWiHiA7KRD17h68A2Dw8TNdGIxtP2meAUobPiLhhTP9eNdjpK6XCQZZhI46jN4VApVrP8ws1AHsAPTBm7/XZA/4eBg1ro61/yZ73b20ZlpH9bAMXLmmZdqlV0lqBeePnI8019V1QpVoGEG1nH0oZ3ge4A4i7zPjucjzPTsSXidBNEnFxeujPG94NKcMnAN8hotUqQGY+YMbmvB3qXMBVgJX3Yd2w3N/CM/wJuhUCLKVcXvMAAAAASUVORK5CYII="
																																							alt="" style="width: 28px; height: 28px;">
							<span data-v-53517552=""
										class="col000 f18 ml15">取卡密码</span></div>
						<div data-v-53517552="">
							<input v-model="order.pwd" data-v-53517552="" placeholder="[必填]请输入取卡密码(6-20位)"
										 class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
							<div data-v-53517552="" class="f12 col666 mt10">添加密码可以增加取卡密的安全性</div>
						</div>
						<div data-v-53517552="" class="mv20">
							<div data-v-53517552="" class="ivu-divider ivu-divider-horizontal ivu-divider-default">
								<!---->
							</div>
						</div>
					</div>

					<div data-v-53517552="" class="flex-start align-center mb10" v-show="isCoupon===1">
						<img data-v-53517552="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAVdJREFUSEvt1jFLw0AYBuD3YqBToUvB4a49SgVXt47+BEGkowquUv0H3XRwcHBwcxQn3XRwEVycRFwchF6bK3TwBzi090qUFINCCzlSKd4WknzPvV9ylwjkPETOHv5B7x2fbUullHVg4QBA3VO0ATA6tNbeJfXGCUslXSoW3bNz4l4I3AaBGGZFSdcAxBY5WrXWPsT1xqBSukm6I2t7Kiv0/X6lqpcATRT19lNgpaI3neOetd0Vv2DlLK4XRb3t2YMk286x7TNhEGAHwOuvCUmeknjxCQoBDfDqb7R0/l+aJGGtVjsnGXY6nY2sz1OpKZaF1roZQ8aYi1zArEh6p5kiYS6glNV1gMdhGCwZY959oVJWr+OFb213N7W1fX0t+EhiAPDGByiEWAaw5tyw0e/3n1JgfFAu68VCwbWAzwt9jDdyeJJgP0AfwqQas/3FmDQ7H+fnP+EHZj3OHeu4hYAAAAAASUVORK5CYII=" alt="" style="width: 28px; height: 28px;">
						<span data-v-53517552="" class="col000 f18 ml15">优惠券</span>
					</div>

					<div data-v-53517552="" v-show="isCoupon===1">
						<input data-v-53517552="" v-model="order.couponCode" @input="validCoupon" placeholder="请输入优惠券码"
									 class="ivu-input ivu-input-default" style="width: 220px; height: 34px;">
						<div data-v-53517552="" class="f12 col666 mt10">使用优惠券码可优惠购买</div>
					</div>

					<div v-show="isCoupon===1">
						<p class="f12 col666 mt10" style="color: green !important;" v-if="order.couponCode && coupon">当前优惠券优惠：{{ coupon.type === 1 ? (coupon.couponAmount + "元") : coupon.couponAmount + "%" }}</p>
						<p class="f12 col666 mt10" style="color: red !important;" v-else-if="order.couponCode && !coupon">{{ couponError }}</p>
					</div>
					<div data-v-53517552="" class="mv20" v-show="isCoupon===1">
						<div data-v-53517552="" class="ivu-divider ivu-divider-horizontal ivu-divider-default">
						</div>
					</div>

					<div data-v-53517552="" class="flex-start align-center mb10"><img data-v-53517552=""
																																						src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAVdJREFUSEvt1jFLw0AYBuD3YqBToUvB4a49SgVXt47+BEGkowquUv0H3XRwcHBwcxQn3XRwEVycRFwchF6bK3TwBzi090qUFINCCzlSKd4WknzPvV9ylwjkPETOHv5B7x2fbUullHVg4QBA3VO0ATA6tNbeJfXGCUslXSoW3bNz4l4I3AaBGGZFSdcAxBY5WrXWPsT1xqBSukm6I2t7Kiv0/X6lqpcATRT19lNgpaI3neOetd0Vv2DlLK4XRb3t2YMk286x7TNhEGAHwOuvCUmeknjxCQoBDfDqb7R0/l+aJGGtVjsnGXY6nY2sz1OpKZaF1roZQ8aYi1zArEh6p5kiYS6glNV1gMdhGCwZY959oVJWr+OFb213N7W1fX0t+EhiAPDGByiEWAaw5tyw0e/3n1JgfFAu68VCwbWAzwt9jDdyeJJgP0AfwqQas/3FmDQ7H+fnP+EHZj3OHeu4hYAAAAAASUVORK5CYII="
																																						alt="" style="width: 28px; height: 28px;">
						<span data-v-53517552=""
									class="col000 f18 ml15">支付方式</span></div>
					<div data-v-53517552="" class="pay-list-box mb40">
						<div data-v-53517552="" name="ivuRadioGroup_1673586798255_0"
								 class="ivu-radio-group ivu-radio-group-default ivu-radio-default">
							<label v-if="alipay" @click="changeGateway('alipay')" data-v-53517552=""
										 :class="['ivu-radio-wrapper', 'ivu-radio-group-item', 'ivu-radio-default', 'ivu-radio-border', order.gateway === 'alipay' ? 'ivu-radio-wrapper-checked' : '']">
                  <span class="ivu-radio ivu-radio-checked">
                    <span class="ivu-radio-inner"></span>
                    <input type="radio" class="ivu-radio-input"
													 name="ivuRadioGroup_1673586798255_0"></span>
								<i data-v-53517552="" class="iconfont icon-zhifubao"></i>
								<span data-v-53517552="" class="ml10">支付宝支付</span>
								<i data-v-53517552="" class="iconfont iconxuanze"></i>
							</label>
							<label v-if="weixingzh" @click="changeGateway('weixingzh')" data-v-53517552=""
										 :class="['ivu-radio-wrapper', 'ivu-radio-group-item', 'ivu-radio-default', 'ivu-radio-border', order.gateway === 'weixingzh' ? 'ivu-radio-wrapper-checked' : '']">
                <span class="ivu-radio ivu-radio-checked">
                    <span class="ivu-radio-inner"></span>
                    <input type="radio" class="ivu-radio-input"
													 name="ivuRadioGroup_1673586798255_0"></span>
								<img src="@/assets/img/default1/wx.png" alt="">
								<span data-v-53517552="" class="ml10">微信支付</span>
								<i data-v-53517552="" class="iconfont iconxuanze"></i>
							</label>
              <label v-if="yunshanfuwap" @click="changeGateway('yunshanfuwap')" data-v-53517552=""
                     :class="['ivu-radio-wrapper', 'ivu-radio-group-item', 'ivu-radio-default', 'ivu-radio-border', order.gateway === 'yunshanfuwap' ? 'ivu-radio-wrapper-checked' : '']">
                  <span class="ivu-radio ivu-radio-checked">
                    <span class="ivu-radio-inner"></span>
                    <input type="radio" class="ivu-radio-input"
                           name="ivuRadioGroup_1673586798255_0"></span>
                <img src="@/assets/img/default1/quickpass.png" alt="">
                <span data-v-53517552="" class="ml10">云闪付</span>
                <i data-v-53517552="" class="iconfont iconxuanze"></i>
              </label>
						</div>
					</div>
					<div data-v-53517552="" class="pay-price flex-between align-center">
						<div data-v-53517552="">
							<div data-v-53517552="" class="flex-start align-center mb25"><img data-v-53517552=""
																																								src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAA5tJREFUSEu1lk+IG1Ucx7+/mQlNQfDSYJq8NxnXggvm0MOCC+6h4qERhFI89LAeFDwoXlrWQ8GWKlbwYHEFBW8q1IMguAfBFQ/dw0KFVkRooUJkN5k3SbbbQw8um83Mez95SWedTSdZL75b3nvz+/z+ve8vhClLCHGCyD0DoMHMswDKROQB6AG4A2AtSZzr3e5Ga5IZyjsol4OgUDBXmPEKEa4DzipzckcptWXvCyGeIvLqgGkw4zUiWo/jvQu9Xm9z3N5jACFqiwAvE9FyGNI1YLM/LUogKErJ7wC4pLV5q9MJv8vePwAQwr9CRK9rHTc6nc6f0w0fPK1UKs+6bmGVmb9Wqv1BeroPkFKeA5yPk2Rwqtvttkql0hPF4tEP+/3dy9vb239Pgvm+/5IxqCvV/uz48adrnmfWmHFJqda39pshYJRz/l3reD71XAhRJXJvA9zs93dfzoNIKU8DzgozVpVqnbW2bCSO461rHc9ZR4cAKWs/AFgPw9a1rKeVSmXWdQs38iAZ42tK0dlsraSsvWcMn4ii9htkvfc8c0spR+YVNA8yzfjIwaAohAkHA54nSwP4WBi2L0zKcxbCTMu2dZnxmOfZ76X0PzWGlAX8AphPwjD8OXvB9/0XjKHP97uB+BhAIv3NjHsA0hZ+WCwWGs1mcy89lzI4DZh3LaDLrOeUUlEWIETwPMAXx6IqE2GeGSvZfWZ+GEXO29kUV6tVQeTetAAOw1YBQHJY30sZnAF4JQxHzXHI8oTwd0kIP1aqffT/AEhZiy0gBMz8eIpKpaB85Ig5d9BLqhPhTWY+P7b/IH1Y6b5NkeN4tyYWWYjaq0T4/rA8pOdJwnPdbvu3vCIvASzy2nRmZubJLGAw0EN11ZoXikXPyvVw7ezsJFtbWzs5bfqApJTPMNOvnufIzc3pypkW2RjnZBRt/DEpuiAIikliQq3duUdS4X8FUDMMWx9NS8l/BUhZW2LGgtWnIWCkgvq21u5Cp7MxUaZTQBxzvddr381zplIJZl2XbybJ4OS+2NmLdtAQ4Woc772YN5lGxqzG8KJSrW/y2vqRKt/Q2lxMB8+EgeM0pkUyxfOfJg6cf9trOHi+BHDVdemLwwpvC6o1L43eBp0ffw+5T97WxHXNMsAL6dA3Jr4bRZH9N4FqtVp2nMJz6dBnxo/GxO/bnI9HN1VTbE5dlxcdh08BVLfDj5mtZvWIcM8YWo1js3L/fvjXpO77B0ua+uYuZrhdAAAAAElFTkSuQmCC"
																																								alt="" style="width: 24px; height: 24px;">
								<span data-v-53517552=""
											class="col000 f20 ml15 b">支付金额</span></div>
							<div data-v-53517552="" class="flex-start align-center f18"
									 style="color: rgb(29, 29, 31);">
								<p data-v-53517552="" class="mr30"><span data-v-53517552="">商品价格：</span> <span
									data-v-53517552="" class="col333">￥{{ goods ? Math.round(order.price * this.order.quantity * 100) / 100 : 0 }}</span>
								</p>
								<p data-v-53517552="" class="mr30"><span data-v-53517552="">手续费：</span> <span data-v-53517552=""
																																															class="col333">￥{{ fee }}</span>
								</p>
								<p data-v-53517552=""><span data-v-53517552="">优惠金额：</span> <span data-v-53517552=""
																																									class="col333" style="color:red;">-{{ couponAmount }}</span>
								</p>
							</div>
						</div>
						<div data-v-53517552="" class="flex-start align-center">
							<div data-v-53517552=""><span data-v-53517552="" class="f20"
																						style="color: rgb(29, 29, 31);">合计：<span data-v-53517552=""
																																										 style="color: rgb(229, 81, 81);">￥</span></span>
								<span data-v-53517552=""
											class="colF71148 f30 b">{{ payAmt }}</span></div>
							<!-- <div @click="submit" style="cursor:pointer" data-v-53517552="" class="confirm-order-btn f16 flex-center align-center">确认订单
							</div> -->
							<el-button :loading="loading" @click="submit" class="confirm-order-btn f16 flex-center align-center">
								确认订单
							</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div data-v-057a54f2="" class="qrcode p10 pointer">
			<vue-qr v-if="qrCodeUrl" class="qr-code" :text="qrCodeUrl" :logoScale="0.2" :logoMargin="3" :margin="20" colorDark="#000" colorLight="#fff"/>
		</div>

		<el-dialog title="商家公告" :visible.sync="dialogVisible" width="30%">
			<div>
				{{ merchant ? merchant.gonggao : "" }}
			</div>
			<span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">已了解</el-button>
        </span>
		</el-dialog>
	</div>
</template>

<script>
import { listGoodsByShop, getConfig, getCoupon, listGoodsByCategory, listGoodsByGoods, getGoods, createOrder, prePay, pay, getMerchant } from "@/api/goods";
import { validatenull, validPhone, validatEmail, validatZnum, validatWx, validatQQ }                                                     from "@/utils/validate";
import vueQr                                                                                                                             from "vue-qr";

export default {
	name       : "IndexDefault",
	components : { vueQr },
	data () {
		return {
      isList              : false,
      searchTitle         :"",
      searchList          : [],
			cateList           : [],
			cateGoodsList      : [],
			goodsList          : [],
			selectedCateid     : null,
			telClass           : "",
			remark           : "",
			goods              : null,
      minLimit:0,
      maxLimit:0,
			merchant           : {},
			openid             : null,
			order              : {
				contact  : null,
				gateway  : null,
				quantity : 1,
				price    : 0,
				goodid   : null,
				isEmail  : false,
				email    : null,
				isTel    : false,
				tel      : null,
				pwd      : null,
			},
			orderRes           : {},
			smsFee             : 0.1,
			loading            : false,
			qrCodeUrl          : null,
			dialogVisible      : false,
			config             : {},
			coupon             : null,
			couponError        : "优惠券不存在",
			goodlistManzengVos : [],
			isCoupon           : 0,

		};
	},
	created () {
		const type   = this.$route.params && this.$route.params.type;
		const linkId = this.$route.params && this.$route.params.linkId;
		if ( !type || !linkId ) {
			this.$message.error("链接无效");
		}
		// 获取配置信息
		this.loadConfig();
		// 获取商户信息
		this.loadMerchant(type, linkId);
		// 获取商品信息
		this.loadGoods(type, linkId);
	},
	mounted () {
		this.qrCodeUrl = window.location.href;
	},
	watch    : {
		"order.quantity" (newVal, oldVal) {
			if ( this.goods.isWholesale !== 1 ) {
				return false;
			}
			this.order.price = this.goods.price;
			this.goods.goodlistWholesaleVos.sort((a, b) => b.pfQuantity - a.pfQuantity);
			for (let index = 0 ; index < this.goods.goodlistWholesaleVos.length ; index++) {
				if ( newVal >= this.goods.goodlistWholesaleVos[index].pfQuantity ) {
					this.order.price = this.goods.goodlistWholesaleVos[index].pfPrice;
					break;
				}
			}
		},
	},

	computed : {
		kucunDesc  : function () {
			if ( !this.goods || this.goods.kucunShow === 0 ) {
				return "";
			}
			if ( this.goods.kucun === 0 ) {
				return "库存不足";
			}
			else if ( this.goods.kucun < 100 ) {
				return "少量库存";
			}
			else {
				return "库存充足";
			}
		},
		kucunColor : function () {
			if ( !this.kucunDesc ) {
				return "#999";
			}
			else if ( this.kucunDesc === "库存不足" ) {
				return "red";
			}
			else if ( this.kucunDesc === "少量库存" ) {
				return "orange";
			}
			else {
				return "green";
			}
		},
		// 订单金额
		orderTotal : function () {
			if ( !this.goods || !this.goods.price || !this.order.quantity ) {
				return 0;
			}
			return Math.round(this.order.price * this.order.quantity * 100) / 100;
		},
		fee        : function () {
			let amount = 0;
			if ( this.order.gateway && this.goods && this.goods.buyerFee === 2 ) {
				const vo = this.merchant.merchantRateVos.find(item => item.gateway === this.order.gateway);
				amount   = Math.round(((1 - vo.rate) * (this.orderTotal - this.couponAmount)) * 100) / 100;
			}
			if ( this.order.isTel ) {
				amount = Math.round((amount + this.smsFee) * 100) / 100;
			}
			return amount;
		},
		payAmt     : function () {
			let sum = this.orderTotal;
			sum     = sum + this.fee;
			sum     = sum - this.couponAmount;
			return Math.round(sum * 100) / 100;
		},
		// 优惠金额
		couponAmount : function () {
			if ( !this.goods || !this.coupon ) {
				return 0;
			}
			if ( this.coupon.type === 2 ) {
				return Math.round(this.orderTotal * (this.coupon.couponAmount / 100) * 100) / 100;
			}
			else {
				return this.coupon.couponAmount;
			}
		},
    yunshanfuwap       : function () {
      if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
        return false;
      }
      let isVisible=  this.merchant.merchantRateVos.findIndex(item => item.gateway === "yunshanfuwap") >= 0;
      // console.log("alipay isVisible",isVisible);
      if ( isVisible === false ) {
        this.changeGateway(null)
      }
      return isVisible;
    },
		alipay       : function () {
			if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
				return false;
			}
			let isVisible=  this.merchant.merchantRateVos.findIndex(item => item.gateway === "alipay") >= 0;
			// console.log("alipay isVisible",isVisible);
			if ( isVisible === false ) {
				this.changeGateway(null)
			}
			return isVisible;
		},
		weixingzh    : function () {
			if ( !this.merchant || !this.merchant.merchantRateVos || this.merchant.merchantRateVos.length <= 0 ) {
				return false;
			}
			let isVisible= this.merchant.merchantRateVos.findIndex(item => item.gateway === "weixingzh") >= 0;
			// console.log("weixingzh isVisible",isVisible);
			if ( isVisible === false ) {
				this.changeGateway(null)
			}
			return isVisible;
		},
	},
	methods  : {
		// 复制操作
		_copy (context) {
			// 创建输入框元素
			let oInput   = document.createElement("input");
			// 将想要复制的值
			oInput.value = context;
			// 页面底部追加输入框
			document.body.appendChild(oInput);
			// 选中输入框
			oInput.select();
			// 执行浏览器复制命令
			document.execCommand("Copy");
			// 弹出复制成功信息
			this.$message.success("复制成功");
			// 复制后移除输入框
			oInput.remove();
		},
		// 加载商户
		loadMerchant (type, linkId) {
			getMerchant(type, linkId).then(res => {
				if ( res.code !== 200 ) {
					this.$router.push("/404");
				}
				document.title = res.data.sitename;
				this.merchant  = res.data;
				localStorage.setItem("merchant", JSON.stringify(res.data));

				// 公告是否弹出
				if ( res.data.isAlertGonggao ) {
					this.dialogVisible = true;
				}
			});
		},
		loadConfig () {
			getConfig().then(res => {
				this.config = res.data;
			});
		},
		// 加载分类商品
		loadGoods (type, linkId) {
			this.cateList  = [];
			this.goodsList = [];
			if ( type === "shop" ) {
				listGoodsByShop(linkId).then(res => {
					// 分类
					res.data.forEach(item => {
						if ( this.cateList.findIndex(d => d.id === item.cateid) === -1 ) {
							this.cateList.push({ id : item.cateid, name : item.catename });
						}
					});
					// 分类数量
					this.cateList.forEach(cate => {
						cate.count = res.data.filter(g => g.cateid === cate.id).length;
					});
					// 商品
					this.goodsList = res.data;
					// 默认选中第一个分类
					this.handleChangeCate({ id : res.data[0].cateid });
				});
			}
			else if ( type === "category" ) {
				listGoodsByCategory(linkId).then(res => {
					if ( res.code !== 200 ) {
						return this.$message.error(res.msg);
					}
					// 商品
					this.goodsList      = res.data;
					this.selectedCateid = res.data[0].cateid;
					this.goodsList.forEach(item => {
						this.cateGoodsList.push({ id : item.id, name : item.goodname });
					});
					this.handleChangeGoods(this.goodsList[0].id);
				});
			}
			else if ( type === "goods" ) {
				listGoodsByGoods(linkId).then(res => {
					if ( res.code !== 200 ) {
						return this.$message.error(res.msg);
					}
					this.goodsList.push(res.data);
					this.cateGoodsList.push({ id : res.data.id, name : res.data.goodname });
					this.order.goodid = res.data.id;
					this.handleChangeGoods(res.data.id);
				});
			}
		},
		// 选择分类
		handleChangeCate (cate) {
			this.selectedCateid = cate.id;
			this.cateGoodsList  = [];
      this.searchList  = [];
			this.goods          = null;
			const list          = this.goodsList.filter(item => item.cateid === this.selectedCateid);
			list.forEach(item => {
        this.isList = true;
        this.cateGoodsList.push({ id : item.goodid, name : item.goodname });
        this.searchList.push({ id : item.goodid, name : item.goodname });
			});
			this.handleChangeGoods(this.cateGoodsList[0].id);
		},
		// 选择商品
		handleChangeGoods (goodsid) {
			this.order.goodid = goodsid;
			getGoods(this.order.goodid).then(res => {
				if ( res.code !== 200 ) {
					this.$message.warning(res.msg);
					return false;
				}
				this.goods              = res.data;
				// let zzreg               = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
				// this.goods.remark       = this.goods.remark.replace(zzreg, "<a href='$1$2' target='_blank'>$1$2</a>");
				// this.remark = this.HTMLDecode(this.goods.remark);
				this.goods.remark = this.addATagButNotImage(this.goods.remark);
        this.order.quantity = res.data.lowLimit!==0 ? res.data.lowLimit : 1
        if (res.data.kucun !== 0) {
          this.maxLimit=res.data.kucun
        }
        if (res.data.maxLimit !== 0) {
          this.maxLimit = res.data.maxLimit>res.data.kucun ? res.data.kucun : res.data.maxLimit
        } else {
          this.maxLimit = res.data.kucun
        }

        this.minLimit = res.data.lowLimit
				this.isCoupon           = res.data.isCoupon;
				this.order.price        = res.data.price;
				this.goodlistManzengVos = res.data.goodlistManzengVos;
				this.merchant.merchantRateVos=res.data.merchantRateVos
			});
		},
		addATagButNotImage (str) {
			var arr = [];
			str = str.replace(/<\/?\w+[^>]*>/g,function (s) {
				arr.push(s);
				return "\x01";
			});
			str = str.replace(/(http(s)?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-\.\/?%&=]*)?/g,function (s,a) {
				return "<a href='"+(a?"":"http://")+s+"'>"+s+"</a>";
			});
			str = str.replace(/(\b\d{11}\b)/g,"<a href=tel:$1>$1</a>");
			str = str.replace(/\x01/g,function (s) {
				return arr.shift();
			});
			return str;
		},
		// HTML反转义
	 HTMLDecode(text) {
			var temp = document.createElement("div");
			temp.innerHTML = text;
			var output = temp.innerText;
			temp = null;
			return output;
		},
		// 选择短信邮件
		changeNotify () {
			this.order.isEmail = this.order.isTel;
		},
		concatWx () {
			window.open("https://work.weixin.qq.com/kfid/kfcce6bc38ab931ba87", "_blank");
		},
		// 选择支付方式
		changeGateway (val) {
			this.order.gateway = val;
		},
		// 校验表单
		valid () {
			if ( validatenull(this.order.goodid) ) {
				this.$message.warning("请选择商品");
				return false;
			}
			if ( validatenull(this.order.quantity) ) {
				this.$message.warning("请输入购买数量");
				return false;
			}
			if ( !validatZnum(this.order.quantity) ) {
				this.$message.warning("购买数量有误");
				return false;
			}
			if ( !this.goods.kucun || this.order.quantity > this.goods.kucun ) {
				this.$message.warning("库存不足");
				return false;
			}
			if ( validatenull(this.order.contact) ) {
				this.$message.warning("请填写联系方式");
				return false;
			}
			if ( this.goods.contactLimit === 2 && !validatQQ(this.order.contact) ) {
				this.$message.warning("联系方式请填写qq号");
				return false;
			}
			if ( this.goods.contactLimit === 3 && !validPhone(this.order.contact) ) {
				this.$message.warning("联系方式请填写手机号");
				return false;
			}
			if ( this.goods.contactLimit === 4 && !validatWx(this.order.contact) ) {
				this.$message.warning("联系方式请填写微信号");
				return false;
			}
			if ( this.order.isTel && (!this.order.tel || !validPhone(this.order.tel)) ) {
				this.$message.warning("请填写正确的手机号");
				return false;
			}
			if ( this.order.isEmail && (!this.order.email || !validatEmail(this.order.email)) ) {
				this.$message.warning("请填写正确的邮箱地址");
				return false;
			}
			if ( this.goods.isPwd === 1 && validatenull(this.order.pwd) ) {
				this.$message.warning("请填写取卡密码");
				return false;
			}
			if ( this.goods.isPwd === 1 && !validatenull(this.order.pwd) && (this.order.pwd.length < 6 || this.order.pwd.length > 20) ) {
				this.$message.warning("取卡密码长度为6-20位");
				return false;
			}
			if ( validatenull(this.order.gateway) ) {
				this.$message.warning("请选择支付方式");
				return false;
			}
			return true;
		},
    searchGoods () {
      this.cateGoodsList = this.searchList
      let searchContent = this.searchTitle
      let goodList = []
      if (searchContent !== "") {
        goodList= this.cateGoodsList.filter(function (n) {
          return n.name.includes( searchContent )
        })
        let arr = Object.keys(goodList);
        if (arr.length === 0) {
          this.handleChangeGoods(this.cateGoodsList[0].id);
          return this.$message.error("未找到'"+searchContent+"'相关商品！");
        } else {
          this.cateGoodsList = goodList
        }
        this.handleChangeGoods(this.cateGoodsList[0].id);
      }
    },
		// 校验优惠券
		validCoupon () {
			if ( !this.goods || !this.order.couponCode || this.order.couponCode.length < 6 ) {
				return false;
			}
			this.coupon = null;
			getCoupon(this.goods.id, this.order.couponCode).then(res => {
				if ( res.code === 200 ) {
					this.coupon = res.data;
				}
				else {
					this.couponError = res.msg;
				}
			});
		},
		// 提交
		submit () {
			if ( !this.valid() ) {
				return false;
			}
			this.order.isTel   = this.order.isTel ? 1 : 0;
			this.order.isEmail = this.order.isEmail ? 1 : 0;

			this.loading = true;
			createOrder(this.order).then(res => {
				this.loading = false;
				if ( res.code !== 200 ) {
					return this.$message.error(res.msg);
				}
				this.orderRes           = res.data;
				this.orderRes.avatarUrl = this.goods.avatarUrl;
				let routeData           = this.$router.resolve({ path : "/pay", query : { orderid : res.data.orderid } });
				window.open(routeData.href, "_blank");
			});
		},
		// 预支付
		doPrePay () {
			prePay(this.orderRes.orderid).then(res => {
				if ( res.code !== 200 ) {
					return this.$message.error("下单失败！");
				}
				this.doPay(res.data);
			});
		},
		// 去支付
		doPay (data) {
			pay({
				ap : data.providerDirectory, pid : data.providerId, orderid : data.orderid, openid : this.openid,
			}).then(res => {
				if ( res.code !== 200 ) {
					return this.$message.error("下单失败！");
				}
				this.loading = false;
				if ( res.data.infoType === "html" ) {
					const div     = document.createElement("div");
					div.innerHTML = res.data.infoData;
					document.body.appendChild(div);
					document.forms[1].submit();
				}
				else if ( res.data.infoType === "url" ) {
					window.open(res.data.payUrl);
				}
			});
		},
		// 获取微信code
		getWechatCode () {
			window.location.href = `https://open.weixingzh.qq.com/connect/oauth2/authorize?appid=wx076c77fcd9783440&redirect_uri=${ encodeURIComponent(window.location.href) }&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
		},
	},
};
</script>

<style lang="less" scoped>
@import '../../../assets/style/default1/font.css';
@import '../../../assets/style/default1/css.css';
.search_box{
  width: 100%;
  padding: .2rem 52px .2rem 0;
  display: flex;
  //padding-right: 52px;
  margin-bottom: 15px;
}
.search_box input{
  flex: 1;
  height: 45px;
  border-radius: 5px 0 0 5px;
  border-color:#722ed1;
  text-indent: 10px;
}
.search_box .search_btn{
  flex: 0.3;
  height:45px;
  line-height: 45px;
  background: #722ed1;
  border-radius: 0 5px 5px 0 ;
  text-align: center;
  color: #fff;
  padding: 2px 0;
}
.sms_active {
	background: #ffa214;
	color: #fff;
}

.email_active {
	background-color: #9460fd;
	color: #fff;
}

.confirm-order-btn {
	margin-left: 36px;
	width: 228px;
	height: 58px;
	background: #722ed1;
	border-radius: 10px;
	color: #fff;
}

.goods-descript /deep/ img {
	max-width: 60%;
}

.qr-code {
	margin-top: 5%;
	margin-left: 43%;
	width: 55%;
}

</style>



// WEBPACK FOOTER //
// src/components/index/default2022/index.vue